import PersonalAreaContainer from './personal-area-container';

export default PersonalAreaContainer;
